import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { useRoute } from "vue-router";
import NavbarComponent from "./shared/components/NavbarComponent.vue";
import NotificacaoComponent from "./shared/components/NotificacaoComponent.vue";
import AlertComponent from "./shared/components/AlertComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const isPublicPage = computed(() => {
  const publicPaths = [
    "/",
    "/login",
    "/auth/cadastro",
    "/auth/recadastro",
    "/integrador/cadastro",
  ];
  return publicPaths.includes(route.path);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "app-background" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (!isPublicPage.value)
            ? (_openBlock(), _createBlock(NavbarComponent, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view),
          _createVNode(NotificacaoComponent),
          _createVNode(AlertComponent)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})